import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  container: {
    padding: "16px",
    backgroundColor: theme.colors.white,
    borderRadius: theme.radius.md,
    boxShadow: theme.shadows.sm,
  },
  historyPlaceholder: {
    padding: "16px",
    backgroundColor: theme.colors.gray[0],
    borderRadius: theme.radius.sm,
    textAlign: "center",
    color: theme.colors.gray[6],
    fontSize: theme.fontSizes.md,
  },
  historyList: {
    maxHeight: "300px",
    overflowY: "auto",
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.sm,
    padding: "8px",
  },
  historyItem: {
    padding: "8px",
    borderBottom: `1px solid ${theme.colors.gray[2]}`,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  noteText: {
    fontSize: theme.fontSizes.md,
    color: theme.colors.gray[7],
  },
  dateText: {
    fontSize: theme.fontSizes.sm,
    color: theme.colors.gray[6],
    marginTop: "4px",
    marginBottom: 0,
  },
}));